<template>
    <div class="col-12 col-md-6 col-xl-3">
            <h5 data-test="footerHead7" id="footerHead7">{{$t(data.moduleHeading)}}</h5>
            <div class="wp_newsLeterFormContainer">
              <p
                data-test="footerHead8"
                id="footerHead8"
              >{{$t(data.descriptionText)}}</p>
              <news-letter-form :data="data"></news-letter-form>
            </div>
          </div>
</template>
<script>

import NewsLetterForm from '@/components/shared/forms/newsLetterForm'

export default {
	props: {
		data: {
			type: Object
		}
	},
	components: {
		NewsLetterForm
	}
}
</script>
